<div class="flex !mt-2 bg-palette-base-white rounded-lg border general-information-ota-section">
    <div class="!p-6 !w-[31.55%]">
        <p class="!text-lg font-semibold text-palette-gray-900">{{'OTA.PROPERTY_PHOTOS.PROPERTY_PHOTOS' | translate}}</p>
        <p class="!text-sm text-palette-gray-700 !mt-1">{{'OTA.PROPERTY_PHOTOS.UPLOAD' | translate}}</p>
    </div>
    <div class="!p-6 !w-[68.45%] ota-location-form">
        <div class="w-full max-w-[588px] box-content flex flex-col !gap-4">
            <div *ngIf="!disabled" class="flex flex-col !gap-2 w-full">
                <div class="hover-element flex flex-col justify-center items-center w-full max-w-[564px] h-full rounded-xl border border-palette-gray-300 cursor-pointer"
                    ngClass="{{dragAreaClass}}" 
                    (dragover)="onDragOver($event)" 
                    (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)"
                    (click)="file.click()" 
                    (mouseover)="onDragOver($event)"
                    (mouseleave)="onDragLeave($event)">
                    <div class="flex flex-col justify-center items-center w-full gap-3 !px-6 !py-4">
                        <div class="flex justify-center items-center !w-8 h-8 p-2 rounded-full border-4 iconStyle">
                            <i class="sctr-icon-upload-cloud-01 !w-4 !h-4"></i>
                        </div>
                        <div class="flex flex-col items-center justify-center gap-1">
                            <div class="flex">
                                <a class="text-palette-blue-600 text-[14px] font-inter font-medium leading-5"
                                    href="javascript:void(0)">{{'OTA.PROPERTY_PHOTOS.CLICK_UPLOAD' | translate}}</a>
                                <p class="text-[14px] font-inter font-normal leading-5 text-palette-gray-700">
                                    &nbsp;{{'OTA.PROPERTY_PHOTOS.DRAG' | translate}}
                                </p>
                                <input type="file" 
                                        #file 
                                        [multiple]="true"
                                        (change)="onFileChange($event)"
                                        style="display:none" accept=".jpg, .svg, .png, .gif"/>
                            </div>
                            <p class="text-palette-gray-500 text-[12px] font-inter font-normal leading-4">
                                {{'OTA.PROPERTY_PHOTOS.ACCEPTS' | translate}}
                            </p>
                        </div>
                    </div>
                </div>
                <p class="text-palette-gray-500 text-[12px] font-inter font-normal leading-4">
                    {{'OTA.PROPERTY_PHOTOS.RECOMMENDED' | translate}} <br> {{'OTA.PROPERTY_PHOTOS.MIN_SIZE' |
                    translate}} <br> {{'OTA.PROPERTY_PHOTOS.FILE_SIZE' | translate}}</p>
            </div>
            <div *ngIf="draggedFiles && draggedFiles.length > 0" class="flex flex-col w-full gap-2">
                <!-- <p class="text-[14px] font-inter font-medium leading-5 text-palette-gray-700">
                    {{'OTA.PROPERTY_PHOTOS.CLICK_MAIN_PHOTO' | translate}}
                </p> -->
                <div class="flex flex-wrap gap-2 !m-0 overflow-auto">
                    <div *ngFor="let file of draggedFiles; let idx = index"
                        class="relative w-full min-w-[100px] max-w-[100px] aspect-square cursor-pointer">
                        <div *ngIf="idx === mainPhoto"
                            class="absolute top-0 left-1/2 -translate-x-1/2 w-[71px] h-[20px] px-2 py-0.5 bg-palette-blue-600 text-[10px] leading-4 font-semibold text-white rounded-b">
                            {{'OTA.PROPERTY_PHOTOS.MAIN_PHOTO' | translate}}
                        </div>

                        <img *ngIf="file" [src]="file.url" class="w-full h-full object-cover"
                             (click)="showImagePopup(file.url)" [ngClass]="(idx === mainPhoto) ? 'image-main' : 'item'">
                    </div>
                    <div *ngIf="loadingFileFromLocal"
                        class="relative w-full min-w-[100px] max-w-[100px] aspect-square bg-palette-gray-50 rounded-lg flex items-center justify-center">
                        <app-loading></app-loading>
                    </div>
                </div>
            </div>
            <div *ngIf="isCheckBoxDirty && draggedFiles.length < 4" class="invalid-feedback flex items-center gap-1">
                <span class="flex items-center"><i class="sctr-icon-alert-circle"></i></span>
                {{'OTA.ROOM_PHOTOS.UPLOAD' | translate}}
            </div>
        </div>
    </div>
</div>

<!-- Modal img -->
<div *ngIf="selectedImageUrl" class="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[10000] overflow-auto p-4">
  <div class="relative">
    <img [src]="selectedImageUrl" class="max-w-full max-h-[90vh] rounded-lg" />
    <button (click)="closeImage()" class="w-[25px] h-[19px] flex items-center p-[11px] justify-center absolute top-2 right-2 rounded-full border border-palette-gray-300 bg-palette-gray-50 text-black text-[19px] font-bold z-10">&times;</button>
  </div>
</div>

<app-toast [keyToast]="'FILE_ERROR'"></app-toast>